import React from 'react';
import styled, { css } from 'styled-components';
import { globalTheme, useMixin } from '@clds/component-theme';
import { UnfoldMore } from '@clds/icon';
import { Button } from '@clds/button';
import { VIEWS_TYPES } from '../colorPickerUtils';
import { useToggleView } from '../hooks/useToggleView';
import { HexView } from './HexView';
import { RgbView } from './RgbView';
import { HslView } from './HslView';

export const flex = css`
  display: flex;
`;

export const MultipleColorInputWrapper = styled.div`
  ${flex};
  width: 100%;
`;

export const ToggleView = styled(Button).attrs({ size: 'sm', tone: 'plain' })`
  margin-left: ${globalTheme.spacing.sm};
  flex-shrink: 0;
`;

export const ColorInputWrapper = styled.div`
  ${flex};
  align-items: flex-start;
`;

const VIEWS_MAP = {
  [VIEWS_TYPES.HEX]: HexView,
  [VIEWS_TYPES.HSL]: HslView,
  [VIEWS_TYPES.RGB]: RgbView,
};

export const ColorInputControl = ({ color, onChange }) => {
  const { currentView, handleSwitchView } = useToggleView(VIEWS_TYPES.HEX, color.rgb?.a);
  const ToggleIconColor = useMixin(globalTheme.palette.contrastHigh);
  const View = VIEWS_MAP[currentView];
  return (
    <ColorInputWrapper>
      <MultipleColorInputWrapper>
        <View value={color[currentView]} onChange={onChange} />
      </MultipleColorInputWrapper>
      <ToggleView leftSlot={<UnfoldMore color={ToggleIconColor} />} onClick={handleSwitchView} />
    </ColorInputWrapper>
  );
};
